__turbopack_context__.v({
  "image": "NewsMediaBlock-module-scss-module__9gceDW__image",
  "imageContent": "NewsMediaBlock-module-scss-module__9gceDW__imageContent",
});
